var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardMenuIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 64c-128 0-232 104-232 232h32c0-110 90-200 200-200s200 90 200 200h32c0-128-104-232-232-232z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 94,
    width: 22,
    height: 50,
    rx: 4,
    fill: "#777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 150,
    width: 22,
    height: 50,
    rx: 4,
    transform: "rotate(-30 112 150)",
    fill: "#777"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 255,
    width: 22,
    height: 50,
    rx: 4,
    transform: "rotate(-60 63 255)",
    fill: "#777"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 150,
    width: 22,
    height: 50,
    rx: 4,
    transform: "rotate(30 378 150)",
    fill: "#777"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 427,
    y: 255,
    width: 22,
    height: 50,
    rx: 4,
    transform: "rotate(60 427 255)",
    fill: "#777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 280l148 148-24 24-148-148z",
    fill: "#777",
    transform: "rotate(240 256 280)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 280,
    r: 28,
    fill: "#777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMenuIcon);
export default __webpack_public_path__ + "static/media/dashboardMenuIcon.f33efca82c15e557014fdee2c45791eb.svg";
export { ForwardRef as ReactComponent };